export default {
  googlemapLoader: null,
}



// WEBPACK FOOTER //
// ./src/store/googlemap/state.js